import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import useStateRef from 'react-usestateref'
import { useHistory } from 'react-router-dom';

const CbQuickOrderSuccessModal = (props) => {
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [showCartText, setShowCartText, showCartTextRef] = useStateRef(props.textFlag)
    const history = useHistory();
    const handleGoToCart = () => {
        history.push("/checkout/cart");
    }
    


    return (
        <div>
           
            <div className="modal gx-0 fade c-shopping-list-modal-body" id="quickAddToCartModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md modal-lg-a">
                    <div className="modal-content c-modal">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div class="alert alert-danger d-none text-start" role="alert" id="new-list-error"></div>
                            <div className='container-fluid cart-modal'>
                                <div className='row'>
                                    <div className='col-12 col-lg-6'>

                                        <div className='row align-items-center'>
                                            {showCartTextRef.current === "true" ?
                                                <div className="col-auto d-block">
                                                    <h3 className="modal-title" id="cbSuccessModalTitle">
                                                        Added to Cart
                                                    </h3>
                                                </div> : ""}
                                            <div class="col-12 col-md-auto order-3 order-lg-2 px-lg-0">
                                                <button role="button" class="btn-primary" data-bs-dismiss="modal">Continue Shopping</button>
                                                <button role="button" class="btn-primary" data-bs-dismiss="modal" onClick={handleGoToCart}>Go to Cart</button>
                                            </div>

                                            {/* iteration for valid products */}
                                            <ul className='col-12 order-2 order-lg-3 cart-added-items list-unstyled'>
                                                {props.cartDetails && props.cartDetails.validProducts && props.cartDetails.validProducts.map((item, index) => {
                                                    return (

                                                        <li className='row g-0'>
                                                            <div class="col-auto added-item-label">
                                                                <span class="fwb d-block">Item # {item && item.productId ? item.productId : ""}</span>
                                                                <span class="">Qty: {item && item.quantity ? item.quantity : ""}</span>
                                                            </div>
                                                            <div class="col added-item-content" id="productSpan">
                                                                <span> {item && item.productName ? item.productName : ""}</span>
                                                            </div>
                                                        </li>
                                                    )
                                                })}
                                            </ul>

                                            <ul class="col-12 order-2 order-lg-3 mbok-0 mb-0 ">
                                                <div class="alert alert-danger mb-0 d-none" id="alert-div" role="alert">
                                                    <p class="mb-0">
                                                        <strong>We were unable to add the following items to your cart:</strong>
                                                    </p>
                                                </div>
                                            </ul>

                                            {/* iteration for invalid products */}
                                            <ul className='col-12 order-2 order-lg-3 cart-added-items list-unstyled'>
                                                {props.cartDetails && props.cartDetails.invalidProducts && props.cartDetails.invalidProducts.map((item, index) => {
                                                    return (
                                                        <li className='row g-0'>
                                                            <div class="col-auto added-item-label">
                                                                <span class="fwb d-block">Item # {item && item.productId ? item.productId : ""}</span>
                                                                <span class="">Qty: {item && item.quantity ? item.quantity : ""}</span>
                                                            </div>
                                                            {item && item.productName ?
                                                                <div class="col added-item-content">
                                                                    <span dangerouslySetInnerHTML={{ __html: item.productName }}></span>
                                                                </div>
                                                                : ''
                                                            }

                                                            <div class="col-auto added-item-content">
                                                                <p class="mb-0" style={{ color: "red" }}>{item && item.doNotAddToCartMessage ? item.doNotAddToCartMessage : ""}</p>
                                                            </div>
                                                        </li>
                                                    )
                                                })}


                                                {/* iteration for invalid products only */}
                                                {props.cartDetails && props.cartDetails.response && props.cartDetails.response.map((item, index) => {
                                                    return (
                                                        <li className='row g-0'>
                                                            <div class="col-auto added-item-label">
                                                                <span class="fwb d-block">Item # {item && item.skuId ? item.skuId : ""}</span>
                                                                <span class="">Qty: {item && item.quantity ? item.quantity : ""}</span>
                                                            </div>

                                                            <div class="col-auto added-item-content">
                                                                <p class="mb-0" style={{ color: "red" }}>add-to-cart-not-found</p>
                                                            </div>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CbQuickOrderSuccessModal
